import { type AggDesignOptionDto } from "src/types/AggDesignOptionDto";
import { Compress } from "./Compress";

export function CompressAggDesignDto(designOption: AggDesignOptionDto): Uint8Array {
  return Compress(designOption);
}
